import { gql } from '@apollo/client/core'
import { designerSignupDataFragment } from '/@/data/designer/fragments'
import { designerSignupMembershipPlanPriceFragment } from '/@/common/plans/fragments'
import {
  stripeInvoiceFragment,
  stripeCustomerFragment,
} from '/@/common/accounts/fragments'

export const designerSignupDiscountFragment = gql`
  fragment DesignerSignupDiscountProps on DesignerSignupDiscount {
    id
    name
    description
    terms
    amountOff
    amountOffCents
    percentOff
    duration {
      durationType
      durationInMonths
    }
    appliesToPrices
  }
`

export const designerSignupFragment = gql`
  ${designerSignupDataFragment}
  ${designerSignupMembershipPlanPriceFragment}
  ${designerSignupDiscountFragment}
  ${stripeInvoiceFragment}
  ${stripeCustomerFragment}
  fragment DesignerSignupProps on DesignerSignup {
    id
    createdAt
    updatedAt
    completedAt
    emailAddress
    firstName
    lastName
    level
    stripeCustomerId
    stripeCustomer {
      ...StripeCustomerProps
    }
    stripePriceId
    stripeSubscriptionId
    stripePromotionCode
    membershipPlanPrice {
      ...DesignerMembershipPlanPriceProps
    }
    source
    sourceExtra
    designer {
      ...DesignerSignupDataProps
    }
    type
    discount {
      ...DesignerSignupDiscountProps
    }
    trialDays
    signupSource
    referrerId
    upcomingInvoice {
      ...StripeInvoiceProps
    }
    freeTierV1Experiment
  }
`

export const messageResultFragment = gql`
  fragment MessageResultProps on MessageResult {
    text
    messageType
  }
`

export const designerSignupResultFragment = gql`
  ${designerSignupFragment}
  ${messageResultFragment}
  fragment DesignerSignupResultProps on DesignerSignupResult {
    status
    signup {
      ...DesignerSignupProps
    }
    message {
      ...MessageResultProps
    }
    redirectUrl
  }
`
